const ListGroupedColumns = [
  { id: "name", label: "Name" },
  { id: "channel", label: "Channel" },
  { id: "variant", label: "Variants", noSort: true },
  { id: "thumbnail", label: "Thumbnail", noSort: true },
  { id: "action", label: "Actions", noSort: true },
];
const ListColumns = [
  { id: "name", label: "Name" },
  { id: "channel", label: "Channel" },
  { id: "lineItemAttached", label: "Associations" },
  { id: "size", label: "Size", noSort: true },
  { id: "vendorApproval", label: "Vendor Approval" },
  { id: "thumbnail", label: "Thumbnail", noSort: true },
  { id: "type", label: "Type", noSort: true },
  { id: "action", label: "Actions", noSort: true },
];
const DetailListColumns = [
  { id: "creative", label: "Creative Name" },
  { id: "lineItemName", label: "Line Item Name" },
  { id: "utmName", label: "Utm Name" },
  { id: "active", label: "Active" },
];
const ASSET_TYPES = {
  BANNER: "banner",
  VIDEO: "video",
  NATIVE: "native",
};
export { ListGroupedColumns, ListColumns, DetailListColumns, ASSET_TYPES };
